export default __webpack_public_path__ + "static/media/kausi7-min.ed52935a.jpg";